import KendoMaskedTextBoxMixin from './KendoMaskedTextBoxMixin'

export default {
    name: 'kendo-maskedtextbox',
    mixins: [ KendoMaskedTextBoxMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoMaskedTextBox/index.js